// @ts-nocheck
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { Col } from 'js/components/Grid'

import styles from './Footer.module.css'

const Footer = () => {
    const { data } = useQuery(GET_FOOTER_SITE_DATA)

    const footerLinks = data?.site?.footer || []

    return footerLinks.length === 0 ? null : (
        <Col mobileLandscape={1 / 2} tablet={1 / 2}>
            <div className={styles.wrapper}>
                {footerLinks.map((item, i) => (
                    <a key={i} href={item.link} title={item.title}>
                        {item.title}
                    </a>
                ))}
            </div>
        </Col>
    )
}

const GET_FOOTER_SITE_DATA = gql`
    query GetFooterSiteData {
        site {
            footer {
                title
                link
            }
        }
    }
`

export default Footer
